var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addRow"},[_c('a',{staticClass:"addRow-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('span',{staticClass:"addRow-icon"}),_c('span',{staticClass:"addRow-text"},[_vm._v("Добавить ряд")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }